import React from "react";
import { Accordion, Col, Row, Card, Badge, Table, Button } from "react-bootstrap";
import SubjectsView from "../components/SubjectsView";

interface CurrentClassesViewProps
{
    data: Classes;
}

interface CurrentClassesViewStates
{
    show: boolean;
    target: boolean;
    popOverData: any;
    open: boolean;
}

export default class CurrentClassesView extends React.Component<CurrentClassesViewProps, CurrentClassesViewStates>
{
    constructor(props: CurrentClassesViewProps) 
    {
        super(props);

        this.state = { show: false, target: false, popOverData: null, open: true };
    }

    render(): React.ReactNode 
    {
        return (<React.Fragment>
            <Row>
                <Col><h2>Classes</h2></Col>
                <Col><span className="grayText float-right">Enrollment Overall GPA <Badge variant="light">{this.props.data.overallGPA ? this.props.data.overallGPA : " - "}</Badge></span></Col>
            </Row>
            <Row><Col>
            {
                (this.props.data.classes && this.props.data.classes.length > 0)
                &&
                this.props.data.classes.map((cls: Class, i: number) => 
                {
                    return <Accordion key={i} defaultActiveKey={i == 0 ? "0" : "1"}>
                        <Card>
                            <Accordion.Toggle aria-expanded={this.state.open} onClick={() => this.setState({ open: !this.state.open })} href={"javascript:void(0)"} as={"a"} variant="link" eventKey="0">
                                <Card.Header>
                                    <Row>
                                        <Col xs={6}>
                                            <span style={{ color: "#0E4180" }}><b>{cls.termCode}</b></span>
                                        </Col>
                                        <Col xs={4} className=" text-right">
                                            <b>GPA <span className="badge badge-light">{cls.gpa ? cls.gpa : "-" }</span></b>
                                        </Col>
                                        <Col xs={1} className="text-right chevron">
                                            <i className={this.state.open ? " far fa-chevron-up" : "far fa-chevron-down"}></i>
                                        </Col>
                                    </Row>
                                </Card.Header>
                            </Accordion.Toggle>
                            <Accordion.Collapse eventKey="0">
                                <Card.Body>
                                    <SubjectsView termCode={cls.termCode} data={cls} />
                                </Card.Body>
                            </Accordion.Collapse>
                        </Card>
                    </Accordion>;
                  
                })
            }
            </Col></Row>
        </React.Fragment>);
    }
}